import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Tooltip } from 'react-tooltip';
import { type LucideIcon } from 'lucide-react';

interface StatCardProps {
  title: string;
  tooltip?: string;
  value: number;
  icon?: LucideIcon;
  value2?: number;
  icon2?: LucideIcon;
  loading?: boolean;
  goto?: string|null;
}

export const StatCard: React.FC<StatCardProps> = ({ 
  title,
  tooltip,
  value, 
  icon: Icon,
  value2, 
  icon2: Icon2,
  loading = false, 
  goto = null
}) => {  
  const navigate = useNavigate();
  return (
  <div onClick={e => navigate(goto || '#')} className={`text-center ${goto && 'cursor-pointer'}`} data-tooltip-id="stat-card-tooltip" data-tooltip-content={tooltip || title}>
    <div className="text-sm font-medium text-gray-300">{title}</div>
    <div className="text-xl font-normal mb-2">
      {loading ? (
        <div className="animate-pulse bg-white/70 rounded h-6 w-12 mx-auto"></div>
      ) : (
        <>
          {Icon && <Icon size={16} className="inline -mt-1 me-2 text-orange-600"/>}
          {value}
          {value2 !== undefined && <span className="border-l-2 border-gray-400 h-1 mx-3"/>}
          {Icon2 && <Icon2 size={16} className="inline -mt-1 me-2 text-orange-600"/>}
          {value2}
        </>
      )}
    </div>
    <Tooltip id="stat-card-tooltip" />
  </div>
)};